import React, { useEffect, useState } from 'react';
import PrismicLink from '../PrismicLink/PrismicLink';
import css from './Dropdowns.module.scss';
import { isFilled } from '@prismicio/helpers';
import cn from 'classnames';

const MenuLink = ({ title, url, targetBlank, desc, icon, setActiveDropdown }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const currentPath = window.location.pathname;
    let urlToCheck = url;

    // Check if the link URL starts with the sharetribe.com prefix, and if so, remove it.
    if (urlToCheck.startsWith('https://www.sharetribe.com')) {
      urlToCheck = urlToCheck.substring('https://www.sharetribe.com'.length);
    }

    // Hack to prevent the /academy/ menu link being highlighted when viewing one of these pages
    const excludedPaths = [
      '/academy/guide/',
      '/academy/marketplace-academy-podcast/',
      '/academy/marketplace-video-course/',
    ];

    if (
      currentPath === urlToCheck ||
      (currentPath.startsWith('/academy/') &&
        !excludedPaths.includes(currentPath) &&
        currentPath.startsWith(urlToCheck))
    ) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [url]);

  const handleClick = () => {
    // Collapses dropdown if user clicks on a link that takes to the current page
    if (isActive) {
      setActiveDropdown(null);
    }
  };

  return (
    <PrismicLink
      to={url}
      targetBlank={targetBlank}
      onClick={handleClick}
      className={cn(css.megamenuLink, {
        [css.withNoIcon]: !isFilled.image(icon),
        [css.active]: isActive,
      })}
    >
      {isFilled.image(icon) ? (
        <div className={css.megamenuLink__icon}>
          <img width={20} height={20} src={icon.url} alt={icon.alt || ''} />
        </div>
      ) : null}

      <div className={css.megamenuLink__copy}>
        {title}
        <span>{desc}</span>
      </div>
    </PrismicLink>
  );
};

export default MenuLink;
